module.exports = __webpack_public_path__ + "static/dailyherald-1be6ee11957639f7c2e8117c97af9093.svg";